import jsonp from 'jsonp'

export type callBackObject = {
  status: string
  toast: {
    variant: 'destructive' | 'default' | null | undefined
    duration: number
    description: string | undefined
    className: string | undefined
  }
}

export async function submitEmailToList(email: string) {
  const url = process.env.NEXT_PUBLIC_MAILCHIMP_ACTION;
  const result = await new Promise<callBackObject>((resolve) => {
    jsonp(`${url}&EMAIL=${email}`, { param: 'c' }, (_, data) => {
      let toastDescription, toastClassName;
      if (data.type === "confirmation") {
        toastDescription = 'Your request has been sent';
        toastClassName = 'bg-[#e1b12c]';
      } else if (data.type === "default") {
        toastDescription = 'Email already exists';
        toastClassName = 'bg-[#e84118]';
      }
      const response: callBackObject = {
        status: data.result,
        toast: {
          variant: 'destructive',
          duration: 2000,
          description: toastDescription || data.msg,
          className: toastClassName
        }
      };
      resolve(response);
    });
  });
  return result;
}

export async function sendDownloadPDF(email: string, audienceId: string) {
  const result = await new Promise<callBackObject>((resolve) => {
    jsonp(`https://canarymission.us10.list-manage.com/subscribe/post-json?u=97f5dcf7e199dea4dc3139b76&amp;id=${audienceId}&EMAIL=${email}`, { param: 'c' }, (_, data) => {
      let toastDescription, toastClassName;
      if (data.result === "success") {
        toastDescription = 'Your request has been sent';
        toastClassName = 'bg-[#e1b12c]';
      } else if (data.type === "default") {
        toastDescription = 'custom';
        toastClassName = 'bg-[#e84118]';
      }
      const response: callBackObject = {
        status: data.result,
        toast: {
          variant: 'destructive',
          duration: 2000,
          description: toastDescription || data.msg,
          className: toastClassName
        }
      };
      resolve(response);
    });
  });
  return result;
}